// Convert English-style figures to Quebec French typography:
//   "2M+" → "2 M+", "70,000" → "70 000", "$30–$55" → "30 $–55 $",
//   "100%" → "100 %", "3.5" → "3,5". Uses non-breaking spaces so the
//   parts never wrap onto separate lines.
const NBSP = " ";

export default function quebecFormat(value) {
  if (typeof value !== "string" || !value) return value;
  return value
    .replace(/(\d),(?=\d{3}\b)/g, `$1${NBSP}`)          // thousands separator
    .replace(/(\d)\.(\d)/g, "$1,$2")                     // decimal comma
    .replace(/\$\s?(\d[\d ,]*)/g, `$1${NBSP}$`)     // $30 → 30 $
    .replace(/(\d)\s?%/g, `$1${NBSP}%`)                  // 100% → 100 %
    .replace(/(\d)\s?([MK])(?=\+|\b)/g, `$1${NBSP}$2`);  // 2M+ → 2 M+
}
